<section class="flex-1 relative overflow-hidden bg-white">
    <div class="max-w-[1400px] mx-auto px-6 py-16 flex flex-col lg:flex-row items-center">

        <!-- Text Content -->
        <div class="lg:w-1/2 z-10 w-full mb-16 lg:mb-0">
            <div class="therapy-headline">
                Ihre Therapie<br>
                <span class="text-app-secondary-10 relative inline-block">
                    digital
                  </span>
                gedacht.
                <div class="seperator">
                    <svg xmlns="http://www.w3.org/2000/svg" height="6" viewBox="0 0 409 6" fill="none">
                        <path d="M0 3C135.836 -0.985116 273.181 -1.01486 409 3C273.164 7.01486 135.819 6.98512 0 3Z"
                              fill="#AE7E1B"/>
                    </svg>
                </div>
            </div>

            <div class="therapy-subheadline">
                Online zum ärztlichen Gespräch &ndash; <br>
                <div class="subline">unkompliziert & vertraulich.</div>
            </div>

            <div class="flex flex-col sm:flex-row gap-4">
                <button class="btn primary-button" (click)="routeToLogin()">
                    <app-icon name="appointment"
                              class="w-[20px] h-[20px] text-white group-hover:scale-110 transition-transform"></app-icon>
                    Termin vereinbaren
                </button>
                <button class="btn quaternary-button" routerLink="/kontakt">
                    <app-icon name="question"
                              class="w-[20px] h-[20px] text-app-secondary-10 group-hover:scale-110 transition-transform"></app-icon>
                    Kontakt aufnehmen
                </button>
            </div>
        </div>

        <!-- Image Content with soft edges -->
        <div class="lg:w-1/2 w-full relative h-[400px] md:h-[500px] items-center justify-center hidden lg:flex">
            <div class="landing-image w-full h-full"></div>
        </div>

    </div>
</section>

<!-- VORTEILE SECTION -->
<section class="bg-app-background-20 py-20 w-full">
    <div class="max-w-[1400px] mx-auto px-6">
        <div class="benefits-header font-fraunce text-center text-app-primary-20 mb-10">
            Ihre Vorteile auf einen Blick
        </div>

        <div
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-y-12 gap-x-6 lg:divide-x divide-gray-300 divide-opacity-60">

            <!-- Vorteil 1 -->
            <div class="flex flex-col items-center text-center px-4 gap-2">
                <div class="h-16 flex items-center justify-center">
                    <app-icon name="location-nope" class="w-[47px] h-[47px] text-app-secondary-10"/>
                </div>
                <div class="info-header">Keine vor-Ort-<br>Termine
                    notwendig
                </div>
                <div class="info-text">Gespräche bequem online<br>durchführen.</div>
            </div>

            <!-- Vorteil 2 -->
            <div class="flex flex-col items-center text-center px-4 gap-2">
                <div class="h-16 flex items-center justify-center">
                    <app-icon name="user-shield" class="w-[47px] h-[47px] text-app-secondary-10"/>
                </div>
                <div class="info-header">Diskrete & flexible<br>Beratung</div>
                <div class="info-text">Bei uns sind Ihre Daten<br>sicher.</div>
            </div>

            <!-- Vorteil 3 -->
            <div class="flex flex-col items-center text-center px-4 gap-2">
                <div class="h-16 flex items-center justify-center">
                    <app-icon name="recipe" class="w-[47px] h-[47px] text-app-secondary-10"/>
                </div>
                <div class="info-header">Digitale Rezept-<br>Ausstellung
                    möglich
                </div>
                <div class="info-text">Schnell, sicher und<br>rechtskonform.</div>
            </div>

            <!-- Vorteil 4 -->
            <div class="flex flex-col items-center text-center px-4 gap-2">
                <div class="h-16 flex items-center justify-center">
                    <app-icon name="pharmacy" class="w-[47px] h-[47px] text-app-secondary-10"/>
                </div>
                <div class="info-header">Einlösung direkt bei<br>uns vor
                    Ort
                </div>
                <div class="info-text">Rezept einlösen und direkt<br>abholen.</div>
            </div>

            <!-- Vorteil 5 -->
            <div class="flex flex-col items-center text-center px-4 gap-2">
                <div class="h-16 flex items-center justify-center">
                    <app-icon name="flower" class="w-[47px] h-[47px] text-app-secondary-10"/>
                </div>
                <div class="info-header">Begleitende<br>Unterstützung</div>
                <div class="info-text">Wir sind auch nach dem<br>Gespräch für Sie
                    da.
                </div>
            </div>

        </div>
    </div>
</section>
